<template>
  <div class="cenbox">
    <div>
      <el-button
        v-if="!titleShow"
        class="back-action"
        link
        :loading="backLoading"
        @click="onBack"
      >
        <el-icon v-if="!backLoading">
          <ArrowLeft />
        </el-icon>
        <span>{{ proxy.$t('Shared.Return') }}</span>
      </el-button>
      <div
        v-show="titleShow"
        class="shoptit"
      >
        切换账号
      </div>
      <div
        v-show="titleShow"
        class="title"
      >
        请选择账户切换
      </div>
      <div
        v-show="!titleShow"
        class="title"
      >
        请选择账户登录
      </div>
      <div class="tit-tip">
        请选择进入
      </div>
    </div>
    <div class="center">
      <div class="shoplist">
        <div
          v-for="(item, i) in resData"
          :key="i"
          :class="['shopItem']"
        >
          <div
            class="card"
            @click="item.isShow = !item.isShow"
          >
            <img
              class="logo"
              src="@/assets/logo/brand.png"
              alt=""
            >
            <div class="shop_title">
              {{ item.tenantName }}
            </div>
            <div class="shop_r">
              <el-icon class="icon">
                <ArrowUpBold v-if="!item.isShow" />
                <ArrowDownBold v-if="item.isShow" />
              </el-icon>
            </div>
          </div>
          <div
            v-show="!item.isShow"
            :class="['brandBox']"
          >
            <div
              v-for="(items, y) in item.brandUserRelationList"
              v-show="items.type == 'data_brand'"
              :key="y"
              class="brand"
              @click="onTenantFn(items)"
            >
              <div class="brand_title">
                {{ items.relationName }}
              </div>
              <div class="brand_r">
                <el-tag type="primary">
                  {{ proxy.$t('role.brand') }}
                </el-tag>
                <el-icon class="icon">
                  <ArrowRightBold />
                </el-icon>
              </div>
            </div>
            <div
              v-for="(items, y) in item.brandUserRelationList"
              v-show="items.type != 'data_brand'"
              :key="y"
              class="brandBoxs"
              @click="onTenantFn(items)"
            >
              <div class="brand brand_bor">
                <div class="brand_title">
                  {{ items.relationName }}
                </div>
                <div class="brand_r">
                  <el-tag
                    v-show="items.type == 'data_shop_group'"
                    type="warning"
                  >
                    {{ proxy.$t('shop.GroupName') }}
                  </el-tag>
                  <el-tag
                    v-show="items.type == 'data_shop'"
                    type="success"
                  >
                    {{ proxy.$t('shop.shop') }}
                  </el-tag>
                  <el-icon class="icon">
                    <ArrowRightBold />
                  </el-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';

const emit = defineEmits(['ontenantFn', 'backToLogin']);

const onBack = () => {
  emit('backToLogin');
};

const { proxy } = getCurrentInstance() as ComponentInternalInstance;
defineProps({
  titleShow: {
    // false：登录    true：切换门店
    type: Boolean,
    required: false,
  },
  resData: {
    type: Array,
    default: () => [],
  },
  backLoading: {
    type: Boolean,
    default: false,
  },
});
onMounted(() => {});
const dialogVisible = ref(false);

// 选择租户
const onTenantFn = (item) => {
  emit('ontenantFn', item);
};
const dialogVisibleFn = () => {
  dialogVisible.value = true;
};
defineExpose({
  dialogVisibleFn,
});
</script>
<style lang="scss" scoped>
.cenbox {
  padding: 10px 0px;
  .back-action {
    margin-bottom: 8px;
    padding: 0;
    color: var(--el-text-color-regular);
    font-size: 14px;

    .el-icon {
      margin-right: 4px;
    }
  }

  .shoptit {
    color: #555;
    font-size: 16px !important;
  }

  .title {
    font-size: 22px;
    color: #111;
    font-weight: 700;
    margin-top: 13px;
  }

  .tit-tip {
    color: #999;
    font-size: 14px;
    margin-top: 6px;
    padding-bottom: 30px;
    font-weight: 500;
  }
}
.center {
  height: 360px;
  overflow-y: auto;
  padding-inline-end: 4px;
  &::-webkit-scrollbar {
    width: 0px; /* 垂直滚动条宽度设为0 */
    height: 0px; /* 水平滚动条高度设为0 */
  }
  &:hover {
    &::-webkit-scrollbar {
      border-radius: 2px;
      width: 4px; /* 垂直滚动条宽度设为0 */
      height: 0px; /* 水平滚动条高度设为0 */
    }
  }

  .shoplist {
    .shopItem {
      background: rgba(248, 249, 250, 0.58);
      padding: 0 10px;
      margin-bottom: 10px;
      border-radius: 10px;
      width: 100%;
      box-sizing: border-box;
      padding-bottom: 10px;
      &.isShow {
        padding-bottom: 10px;
      }

      .card {
        display: flex;
        padding: 20px 0;
        cursor: pointer;
        .logo {
          width: 30px;
          height: 30px;
          vertical-align: middle;
        }

        .shop_title {
          vertical-align: middle;
          max-width: 140px;
          overflow: hidden;
          color: #333;
          font-weight: 700;
          font-size: 18px;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-inline-start: 3px;
        }

        .shop_r {
          flex: 1;
          text-align: end;
          line-height: 30px;
          color: #666;
          .icon {
            margin-inline-start: 10px;
            font-size: 16px;
            color: #999;
          }
        }
      }
      .brandBox {
        background: rgba(255, 255, 255, 0.46);
        border-radius: 10px;
        // padding-bottom: 1px;
        margin-bottom: 10px;
      }
      .brandBoxs {
        padding: 0 15px;
        padding-bottom: 1px;
      }
      .brand {
        display: flex;
        line-height: 30px;
        padding: 14px;
        margin-bottom: 10px;

        &:hover {
          background: rgba(237, 238, 238, 0.68);
          border-radius: 5px;
        }

        .brand_title {
          width: 190px;
          overflow: hidden;
          color: #333;
          font-size: 16px;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .brand_r {
          flex: 1;
          text-align: end;

          .icon {
            position: relative;
            top: 3px;
            margin-inline-start: 10px;
            color: #999;
          }
        }
      }
      .brand_bor {
        border: 1px solid rgba(216, 226, 235, 0.72);
        border-radius: 5px;
        background: rgba(255, 255, 255, 0.36);
      }
    }
  }
}
</style>
